import { computed } from 'vue'
// types
import type { ComputedRef } from 'vue'
import type { FooterPaymentBadgeProps } from '../types/interfaces'
// assets
import { PAYMENT_BADGES } from '../images'

interface FooterPaymentBadgeHookOptions {
  props: FooterPaymentBadgeProps
}

interface FooterPaymentBadgeHookReturn {
  refSrc: ComputedRef<string>
}

export const useFooterPaymentBadge = ({ props }: FooterPaymentBadgeHookOptions): FooterPaymentBadgeHookReturn => {
  const refSrc = computed<string>(() => PAYMENT_BADGES[props.method])

  return {
    refSrc,
  }
}
